'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-headset';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f82d';
var svgPathData = ['M112 160c0 24.5 7.9 47.2 21.2 65.6 15.5-25 43.2-41.6 74.8-41.6l32 0c30.9 0 58.1 15.9 73.8 40l2.2 0c12.7-18.1 20.1-40.2 20.1-64 0-61.9-50.1-112-112-112S112 98.1 112 160z', 'M224 16c-79.5 0-144 64.5-144 144 0 13.3-10.7 24-24 24s-24-10.7-24-24C32 54 118-32 224-32S416 54 416 160l0 136c0 13.3-10.7 24-24 24l-184 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l80 0 0-112c0-79.5-64.5-144-144-144zM153.1 352l141.7 0c75.7 0 137.1 61.4 137.1 137.1 0 12.6-10.2 22.9-22.9 22.9L38.9 512C26.2 512 16 501.8 16 489.1 16 413.4 77.4 352 153.1 352z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserHeadset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;